import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["root", "tab", "trigger"]
    static values = {
        inactiveTabCssClasses: { type: String, default: 'hover:text-gray-600 hover:bg-gray-50' },
        activeTabCssClasses: { type: String, default: 'text-primary-950 font-semibold bg-gray-50' }
    }

    connect() {
        console.log(this.inactiveTabCssClassesValue)
        console.log(this.activeTabCssClassesValue)
        this.displayStyle = this.rootTarget.dataset.displayStyle ?? 'block'
        this.possibleTabIds = this.tabTargets.map(t => t.dataset.tabId)
        this.changeTabTo(location.hash)
        this.onHashChange = this.onHashChange.bind(this)

        if (this.possibleTabIds.length > 0) {
            window.addEventListener('hashchange', this.onHashChange)
        }
    }

    disconnect() {
        if (this.possibleTabIds.length > 0) {
            window.removeEventListener('hashchange', this.onHashChange)
        }
    }

    onHashChange() {
        this.changeTabTo(location.hash)
    }

    changeTab(event) {
        this.changeTabTo(event.target.dataset.tabId)
    }

    changeTabTo(tabId) {
        this.currentTabId = this.possibleTabIds.includes(tabId) ? tabId : this.possibleTabIds[0];
        this.tabTargets.forEach(tab => {
            const triggerEl = this.triggerTargets.find(t => t.dataset.tabId == tab.dataset.tabId)

            if (!triggerEl) return;

            if (this.currentTabId == tab.dataset.tabId) {
                tab.style.display = this.displayStyle
                this.inactiveTabCssClassesValue.split(' ').forEach((val) => triggerEl.classList.remove(val))
                this.activeTabCssClassesValue.split(' ').forEach((val) => triggerEl.classList.add(val))
            } else {
                tab.style.display = 'none'
                this.inactiveTabCssClassesValue.split(' ').forEach((val) => triggerEl.classList.add(val))
                this.activeTabCssClassesValue.split(' ').forEach((val) => triggerEl.classList.remove(val))
            }
        });
    }
}